'use client';

import React from 'react';
import { PresetType, ShortInterestScanner } from '@benzinga/scanner-widget';
import type { ScannerProtos } from '@benzinga/scanner-manager';
import { useSearchParams } from 'next/navigation';
import Hooks from '@benzinga/hooks';

import styles from '../styles.module.scss';

interface Props {
  preset: PresetType;
  scannerData: ScannerProtos.IQueryResponse | null;
}

export const LayoutAbove: React.FC<Props> = ({ preset, scannerData }) => {
  const searchParams = useSearchParams();
  const [selectedPreset, setSelectedPreset] = React.useState<PresetType | null>(preset);

  Hooks.useEffectDidMount(() => {
    const presetFromQuery = searchParams?.get('preset');
    if (presetFromQuery) setSelectedPreset(presetFromQuery as PresetType);
  });

  const onPresetChange = (_query: unknown, presetName: PresetType | null) => {
    if (presetName) {
      window.history.pushState({}, '', `/short-interest/${presetName}`);
    } else {
      window.history.pushState({}, '', `/short-interest`);
    }
    setSelectedPreset(presetName);
  };

  return (
    <div className={styles.ShortInterestTableWrap}>
      <ShortInterestScanner
        initialScannerResult={scannerData}
        onPresetChange={onPresetChange}
        preset={selectedPreset ?? preset}
      />
    </div>
  );
};
